import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { uploadPrefixCls } from "@/base/components/upload/Upload.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Upload">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${uploadPrefixCls}`]: {},
  },
});

export const useUploadStyle = genComponentStyleHook(
  ["Upload", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
